// extracted by mini-css-extract-plugin
export default {"form_section":"Form_form_section__34BrG","form":"Form_form__cIc6e","form_checkbox":"Form_form_checkbox__DGY4b","btn":"Form_btn__kFD9B"};